import React from 'react'
import { ReactComponent as CloseModalIcon } from '../../svg/normalSvgs/CloseModalIcon.svg'
import { ReactComponent as VideoPlayIcon } from '../../svg/normalSvgs/VideoPlayIcon.svg'
import instructionVideo from '../../assets/images/InstructionVideo.png'
import { useTranslation } from 'react-i18next'

function Instruction({ closeVideoContainer, toggleInstructionVideo }) {
    const { t } = useTranslation()
    return (
        <div className="feed-instruction-video-container">
            <div className="instruction-close-logo" onClick={closeVideoContainer}>
                <CloseModalIcon width={9} height={9} />
            </div>
            <div className="feed-instruction-video">
                <div style={{ cursor: 'pointer', marginBottom: 14 }} onClick={toggleInstructionVideo}>
                    <img src={instructionVideo} className="feed-instruction-logo" alt="Be Amazing" height={116} />
                </div>
                <div className="feed-instruction-comand">
                    <VideoPlayIcon style={{ color: '#F8F8FB' }} />
                    <div className="feed-instruction-text">{t('instructionVideo')}</div>
                </div>
            </div>
        </div>
    )
}

export default Instruction
